export function uiModalTriggerDirective(uiModalDeclarationService, $parse) {
  'ngInject';

  return {
    restrict: 'A',
    link: (scope, element, attrs) => {
      const { uiModalTrigger, disabled } = attrs;
      const isDisabled = $parse(disabled)(scope);
      if (uiModalTrigger && !isDisabled) {
        element.bind('click', () => {
          uiModalDeclarationService.open(uiModalTrigger);
        });
      }
    }
  };
}
